<template>
  <div class="order-content">
    <!-- Host -->

    <customer
      v-if="oOrder.payment.payers[0].user"
      :name="oOrder.payment.payers[0].user.name"
      :phone="Utils.phoneMask(oOrder.payment.payers[0].user.phone)"
      :address="
        oOrder.delivery.address ||
        oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS
          ? generateAddr(oOrder.delivery.address)
          : 'Retirada no balcão'
      "
      :auto_close="oOrder.auto_close"
      :type="oOrder.payment.payers[0].user.type"
      :orderTime="this.getArrivedTime(oOrder.created_at)"
      :orderId="oOrder.position"
    />

    <customer
      v-if="!oOrder.payment.payers[0].user"
      :name="StringLanguage.customerNotAssigned"
      :address="
        oOrder.delivery.address
          ? generateAddr(oOrder.delivery.address)
          : 'Retirada no balcão'
      "
      :auto_close="auto_close"
      :orderTime="this.getArrivedTime(oOrder.created_at)"
      :orderId="oOrder.position"
    />

    <!-- Products -->
    <base-card>
      <orders-products :items="oOrder.cart.catalog.items" />
      <!-- for product in products -->
    </base-card>

    <!-- Observação -->
    <base-card v-if="oOrder.observation">
      <p class="text-center fs-14 fw-400 mb_20 color-3">
        {{ StringLanguage.observation }}
      </p>
      <p class="fw-300 fs-12 mt_10">"{{ oOrder.observation }} "</p>
    </base-card>

    <!-- Address -->
    <!-- <base-card v-if="oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS">
      <div class="mb_15 d-flex align-center fs-12">
        <i class="fas fa-map-marker-alt fs-16 mr_15 o-40"></i>
        <p class="o-50">{{ generateAddr(oOrder.delivery.address) }}</p>
      </div> -->

    <!-- MAPA NA fase 2 -->
    <!-- <div v-if="oOrder.delivery.address.geolocation.latitude && oOrder.delivery.address.geolocation.longitude" class="box-address-map">
          <div class="d-flex">
            <l-map
                style="width: 100%; height: 150px;"
                :options="{
                zoomControl: false,
                scrollWheelZoom: false,
                dragging: false,
                touchZoom: false,
                doubleClickZoom: false,
                boxZoom: false,
                keyboard: false
                }"
                :zoom="15"
                :center="[oOrder.delivery.address.geolocation.latitude, oOrder.delivery.address.geolocation.longitude]"
            >
                <l-tile-layer :url="mapConfigs.mapURL" :attribution="mapConfigs.mapAttribution" />
                <l-marker :lat-lng="[oOrder.delivery.address.geolocation.latitude, oOrder.delivery.address.geolocation.longitude]"></l-marker>
            </l-map>
          </div>
        {{oOrder.delivery.geolocation}}
      </div>
    </base-card> -->

    <!-- Payers -->
    <base-card v-if="oOrder.payment.payers.length > 0">
      <order-payers :payers="oOrder.payment.payers" />
    </base-card>

    <!-- Money -->
    <base-card>
      <order-prices
        :total="oOrder.cart.total"
        :delivery="oOrder.delivery.total"
        :discount="getDiscountValue()"
        :addition="getAdditionValue()"
        :gift="oOrder.gift"
      />
    </base-card>

    <!-- Rating -->
    <base-card v-if="order.id && order.origin === 1">
      <order-rating :id="order.id" />
    </base-card>

    <base-card v-if="showFoodyDelivery">
      <div class="foody-delivery">
        <div class="logo">
          <img src="@/assets/img/foody-delivery.png" alt="Foody Delivery" />
        </div>
        <div class="delivery">
          <div v-if="deliveryStatusHistory.length > 0">
            <p v-for="(deliveryStatus, i) in deliveryStatusHistory" :key="i">
              <b>{{ getDeliveryStatusMessage(deliveryStatus.status_id) }}</b> /
              via
              <span>
                <b>
                  {{
                    deliveryStatus.is_external_change
                      ? 'Foody Delivery'
                      : 'Easy Delivery'
                  }}
                </b>
                .
              </span>
            </p>
          </div>
          <div v-else>
            <p>
              <b>{{ StringLanguage.deliveryOrderNothingToShow }}.</b>
            </p>
          </div>
        </div>
        <div class="d-flex">
          <base-button
            design="two"
            class="w-100 mr_15"
            v-if="showReadyButton"
            @click="changeDeliveryStatus(oOrder, 'ready')"
            >Marcar como pronto</base-button
          >
          <base-button
            design="six"
            class="w-100"
            v-if="showSyncButton"
            @click="syncDeliveryInfo(oOrder)"
            :loading="syncIsRunning"
            >Sincronizar com Foody Delivery</base-button
          >
        </div>
      </div>
    </base-card>

    <!-- Actions -->
    <base-card class="d-flex align-center" v-if="!reportRating">
      <base-button
        @click="cancelOrder"
        text="Cancelar pedido"
        design="underline"
        class="w-100"
      />
    </base-card>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import { TheMask } from 'vue-the-mask';
import { Type as UserType } from 'easyjs/lib/Schema/Account/User';
import {
  DeliveryPlatform as DeliveryPlatformEnum,
  PlatformShippingStatus,
} from 'easyjs/lib/Schema/Delivery/DeliveryPlatform';
import { ExceptionCode } from 'easyjs/lib/Exceptions/ExceptionCode';
import Order, { Status } from 'easyjs/lib/Schema/Order';
import { DeliveryType } from 'easyjs/lib/Schema/Delivery';

import { mapState } from 'vuex';
import Utils from '@/utils';
import BaseCard from '@/components/Card';
import BaseButton from '@/components/Button';
import BrasilStates from '@/plugins/states';
import OrdersProducts from '@/containers/Orders/OrdersProducts';
import Customer from '@/containers/Customer';
import OrderPrices from '@/containers/Orders/OrderPrices';
import OrderPayers from '@/containers/Orders/OrderPayers';
import OrderRating from '@/containers/Orders/OrderRating';

// api
import DeliveryPlatformAPI from '@/api/deliveryPlatform';
import OrderAPI from '@/api/order';

export default {
  data() {
    return {
      host: this.order.payment.payers[0],
      DeliveryType,
      UserType,
      TheMask,
      Utils,
      BrasilStates,
      Status,
      oOrder: {},
      mapConfigs: {
        name: 'locationMap',
        zoom: 3,
        minZoom: 3,
        maxZoom: 3,
        bounds: null,
        mapCenter: latLng(-16.755334, -48.856434),
        mapURL: 'https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
        mapAttribution:
          "<a href='https://google.com/maps'>Powered by Google</a>",
        markerPosition: latLng(-16.755334, -48.856434),
      },
      deliveryStatusHistory: [],
      showFoodyDelivery: false,
      showReadyButton: false,
      showSyncButton: false,
      syncIsRunning: false,
    };
  },
  props: {
    order: Object,
    report: Boolean(false),
    reportRating: Boolean(false),
    printers: {},
    auto_close: String,
  },
  beforeMount() {
    const clonedOrder = { ...this.order };
    delete clonedOrder.schedule;

    this.oOrder = Order.fromObject(Object.clone(clonedOrder));
  },
  async mounted() {
    await this.getDeliveryCurrentStatus(this.oOrder);
    await this.getDeliveryStatusHistory(this.oOrder);
  },
  methods: {
    cancelOrder() {
      confirm(StringLanguage.confirmCencel, (res) => {
        if (!res) return false;
        this.$emit('change-status', {
          id: this.oOrder.id,
          status: Status.CANCELLED,
        });
      });
    },
    getArrivedTime(createdAt) {
      if (!createdAt) return '';

      const milliseconds = Utils.toMilliseconds(createdAt);
      let temp = Math.floor(milliseconds / 1000);
      const days = Math.floor((temp %= 31536000) / 86400);

      if (days) {
        return Utils.dateParse(createdAt).replace(' ', ', ');
      }

      return `${StringLanguage.hasArrived} ${Utils.millisecondsToStr(
        milliseconds
      )}`;
    },
    getDiscountValue() {
      const order = this.oOrder;

      if (order.gift && !order.gift.code) {
        if (order.gift.type === 138) return parseFloat(order.gift.value);
        if (order.gift.type === 140)
          return parseFloat((order.gift.value / 100) * order.cart.total);

        return null;
      }

      return null;
    },
    getAdditionValue() {
      const order = this.oOrder;

      if (order.gift && !order.gift.code) {
        if (order.gift.type === 139) return parseFloat(order.gift.value);
        if (order.gift.type === 141)
          return parseFloat((order.gift.value / 100) * order.cart.total);

        return null;
      }
      return null;
    },
    getStatus(status) {
      switch (status) {
        case Status.IN_PRODUCTION:
          return StringLanguage.inProduction;

        case Status.ON_DELIVERY:
          return StringLanguage.onDelivery;

        case Status.FINISHED:
          return StringLanguage.finished;

        default:
          return '';
      }
    },
    generateAddr(oAddress) {
      if (!oAddress) return 'Erro no endereço';

      let stringAddress = `${oAddress.address}`;

      if (oAddress.number) stringAddress += `, ${oAddress.number}`;
      if (oAddress.complement) stringAddress += ` (${oAddress.complement})`;

      const shortNameState = BrasilStates.getShortNameByName(oAddress.state);

      stringAddress += ` - ${oAddress.region} - ${oAddress.city}/${shortNameState}`;

      return stringAddress;
    },
    changeDeliveryStatus(order, newStatus) {
      if (!order || !newStatus) return;

      const { id: orderId } = order;
      const platformId = order.delivery.deliveryPlatformShipping
        ? order.delivery.deliveryPlatformShipping.type_id
        : null;

      if (!platformId) return;

      const platform = Object.keys(DeliveryPlatformEnum).find(
        (platformName) => DeliveryPlatformEnum[platformName] === platformId
      );

      if (
        // eslint-disable-next-line no-prototype-builtins
        !PlatformShippingStatus.hasOwnProperty(String(newStatus).toUpperCase())
      )
        return;

      DeliveryPlatformAPI.putDeliveryStatus(
        String(platform).toLowerCase(),
        orderId,
        newStatus
      ).then(async (response) => {
        const updateDeliveryErrors = response.getErrors([]);
        if (updateDeliveryErrors.length === 0) {
          const updatedOrder = response.getData({});
          this.oOrder = updatedOrder;

          await this.getDeliveryCurrentStatus(updatedOrder);
          await this.getDeliveryStatusHistory(updatedOrder);
          this.$forceUpdate();
        } else {
          let message = `Não foi possível atualizar este pedido: ${updateDeliveryErrors[0]}`;

          if (
            response.getCode(500) ===
            ExceptionCode.FOODY_DELIVERY_ORDER_LIMIT_EXCEEDED
          ) {
            message = StringLanguage.foodyDeliveryOrderLimitExceeded;
          }

          alert(message);
        }
      });
    },

    async getDeliveryCurrentStatus(order) {
      const { id: orderId } = order;
      const platformId = order.delivery.deliveryPlatformShipping
        ? order.delivery.deliveryPlatformShipping.type_id
        : null;
      const orderDeliveryPlatform = Object.keys(DeliveryPlatformEnum).find(
        (platformName) => DeliveryPlatformEnum[platformName] === platformId
      );

      const hasAddressDelivery =
        order.delivery.type === DeliveryType.DELIVER_ON_ADDRESS;

      if (this.hasActiveDeliveryPlatform) {
        this.showFoodyDelivery = hasAddressDelivery;

        if (this.showFoodyDelivery && orderDeliveryPlatform) {
          const response = await DeliveryPlatformAPI.getDeliveryStatus(
            String(orderDeliveryPlatform).toLowerCase(),
            orderId
          );

          if (response.getErrors([]).length === 0) {
            const { status } = response.getData({ status: '' });
            this.showReadyButton =
              PlatformShippingStatus[status] === PlatformShippingStatus.OPEN;
          }
        }
      } else {
        this.showFoodyDelivery = hasAddressDelivery && orderDeliveryPlatform;
      }

      this.showSyncButton =
        this.showFoodyDelivery && this.hasActiveDeliveryPlatform;
    },
    async getDeliveryStatusHistory(order) {
      const { id: orderId } = order;

      const deliveryPlatormShippingId = order.delivery.deliveryPlatformShipping
        ? order.delivery.deliveryPlatformShipping.id
        : null;
      const platformId = order.delivery.deliveryPlatformShipping
        ? order.delivery.deliveryPlatformShipping.type_id
        : null;

      if (!deliveryPlatormShippingId || !platformId) return;

      const platform = Object.keys(DeliveryPlatformEnum).find(
        (platformName) => DeliveryPlatformEnum[platformName] === platformId
      );

      DeliveryPlatformAPI.getDeliveryStatusHistory(
        String(platform).toLowerCase(),
        orderId,
        deliveryPlatormShippingId
      ).then((response) => {
        this.deliveryStatusHistory = response ? response.getData([]) : [];
      });
    },
    getDeliveryStatusMessage(deliveryStatusId) {
      switch (deliveryStatusId) {
        case PlatformShippingStatus.OPEN:
          return StringLanguage.deliveryOrderCreated;

        case PlatformShippingStatus.READY:
          return StringLanguage.deliveryOrderMarkAsReady;

        case PlatformShippingStatus.SENT:
          return StringLanguage.deliveryOrderSent;

        case PlatformShippingStatus.DELIVERED:
          return StringLanguage.deliveryOrderDelivered;

        case PlatformShippingStatus.CLOSED:
          return StringLanguage.deliveryOrderClosed;

        case PlatformShippingStatus.CANCELLED:
          return StringLanguage.deliveryOrderCancelled;

        default:
          return StringLanguage.deliveryOrderNothingToShow;
      }
    },
    syncDeliveryInfo(order) {
      const { id: orderId } = order;
      const platform = Object.keys(DeliveryPlatformEnum).find(
        (platformName) =>
          DeliveryPlatformEnum[platformName] ===
          DeliveryPlatformEnum.FOODY_DELIVERY
      );

      this.syncIsRunning = true;
      OrderAPI.syncDelivery(String(platform).toLowerCase(), orderId).then(
        async (response) => {
          const syncDeliveryErrors = response.getErrors([]);
          if (syncDeliveryErrors.length === 0) {
            const updatedOrder = response.getData({});
            this.oOrder = updatedOrder;

            await this.getDeliveryCurrentStatus(updatedOrder);
            await this.getDeliveryStatusHistory(updatedOrder);

            this.syncIsRunning = false;
            this.$forceUpdate();
          } else {
            let message = `Não foi possível sincronizar este pedido: ${syncDeliveryErrors[0]}`;

            if (
              response.getCode(500) ===
              ExceptionCode.FOODY_DELIVERY_ORDER_LIMIT_EXCEEDED
            ) {
              message = StringLanguage.foodyDeliveryOrderLimitExceeded;
            }

            this.syncIsRunning = false;
            alert(message);
          }
        }
      );
    },
  },
  computed: {
    ...mapState({
      newChangeOrderDelivery: (state) => state.socket.newChangeOrderDelivery,
      hasActiveDeliveryPlatform: (state) =>
        state.deliveryPlatform.tokenConfigurationIsActive,
    }),
  },
  watch: {
    async newChangeOrderDelivery(deliveryPlatformShipping) {
      const hasDeliveryPlatformShipping =
        !!this.oOrder.delivery.deliveryPlatformShipping;

      if (
        hasDeliveryPlatformShipping &&
        this.oOrder.delivery.deliveryPlatformShipping.id ===
          deliveryPlatformShipping.id
      ) {
        this.oOrder.delivery.deliveryPlatformShipping.status_id =
          deliveryPlatformShipping.status_id;
        await this.getDeliveryCurrentStatus(this.oOrder);
        await this.getDeliveryStatusHistory(this.oOrder);
        this.$forceUpdate();
      }
    },
  },
  components: {
    OrdersProducts,
    BaseCard,
    BaseButton,
    Customer,
    OrderPrices,
    OrderPayers,
    OrderRating,
  },
};
</script>
<style scoped>
.customer {
  position: relative;
}
.phone {
  position: absolute;
  right: 15px;
  text-decoration: none;
}
.phone i {
  color: var(--default);
  border: 2px solid var(--default);
  padding: 5px;
  border-radius: 100%;
  font-size: 1.2em;
  margin-left: 15px;
}
.phone span {
  background: var(--default);
  padding: 5px 7px;
  color: white;
  border-radius: 3px;
  font-size: 1.2em;
  margin-left: 15px;
}
.customer-name {
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  padding-right: 120px;
  color: #aaaaaaed;
}

.map-pseudo-marker {
  position: absolute;
  top: calc(50% - 32px);
  left: calc(50% - 16px);
  z-index: 1000;
  width: 32px;
  height: 32px;
}

.map-pseudo-marker i {
  font-size: 32px;
  color: red;
  width: 100%;
  text-align: center;
}

.values {
  color: #777;
}
.values:not(:last-child) {
  margin-bottom: 5px;
}
.total-value {
  font-weight: 900;
}

.foody-delivery {
  border-radius: 5px;
  background: #3e4144;
  padding: 20px;
  overflow: hidden;
}

.foody-delivery .delivery {
  display: flex;
  flex-direction: column;
}

.foody-delivery .delivery p {
  font-size: 12px;
  line-height: 15px;
  padding-bottom: 15px;
}

.foody-delivery .delivery p:not(:nth-child(1)) {
  border-top: 1px solid #ffffff17;
  padding-top: 15px;
}

.foody-delivery .delivery p:last-child {
  padding-bottom: 25px;
}

.foody-delivery .delivery p b {
  font-weight: bold;
}

.foody-delivery .delivery p span b {
  color: var(--default);
}

.foody-delivery .logo {
  background: #424549;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -20px;
  margin-bottom: 20px;
}

.foody-delivery .logo img {
  background: #424549;
  width: 80px;
  opacity: 0.6;
}
</style>
